var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTexhnxt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 96,
    viewBox: "0 0 755 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57,
    clipPath: "url(#clip0_494_3404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.976 95.2007V2.21411H445.695V62.7292H444.212C438.403 52.5203 429.256 44.9559 423.447 34.6856H421.964C422.15 30.9342 418.256 29.2737 416.031 26.5677C414.363 24.5383 412.509 20.6023 410.84 18.4499C406.391 12.7919 401.756 8.48701 398.233 2.21411H377.469V95.2007H396.75V34.6856H398.233C404.042 44.9559 413.189 52.4588 418.998 62.7292H420.481C420.296 66.4806 424.189 68.1411 426.414 70.847C428.082 72.8765 429.936 76.8125 431.605 78.9649C436.054 84.6228 440.689 88.9278 444.212 95.2007H464.976Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.179 62.7291H233.662C240.892 75.5209 257.64 82.3473 264.808 95.2006H279.64C279.64 90.5266 280.938 82.9008 278.899 78.9648C275.562 72.5689 266.91 69.125 263.325 62.7291H261.842C259.494 58.5471 248.493 52.2742 248.493 47.9693C248.493 44.4024 260.174 35.3005 263.325 33.2095H264.808C268.331 26.9981 275.932 23.6772 279.64 17.7118C282.236 13.5913 281.123 7.31843 281.123 2.21401H264.808C257.887 14.4523 242.005 20.9712 235.145 33.2095H232.179C224.948 20.4177 208.2 13.5913 201.032 0.738037H186.2C186.2 5.41196 184.902 13.0378 186.942 16.9738C190.279 23.3697 198.931 26.8136 202.515 33.2095H203.998C205.79 36.346 208.88 38.8059 211.414 41.3274C212.65 42.5574 218.768 47.1083 218.83 48.7073C218.892 50.0603 211.847 55.8412 210.672 56.8252C208.2 58.9161 205.667 59.7156 203.998 62.7291H202.515C198.931 69.125 190.217 72.5689 186.942 78.9648C184.902 82.9623 186.2 90.5266 186.2 95.2006H201.032C208.262 82.4088 225.01 75.5824 232.179 62.7291V62.7291Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.854 59.7772H350.833V95.2007H371.597V2.21411H350.833V40.5895H304.854V2.21411H284.09V95.2007H304.854V59.7772Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.474 33.2095H642.957C646.479 26.9981 654.081 23.6772 657.789 17.7118C660.384 13.5913 659.272 7.31843 659.272 2.21401H644.44C638.322 6.33445 633.316 12.5459 628.125 17.7118C623.367 22.4472 616.569 27.3056 613.293 33.2095H610.327C603.096 20.4177 586.349 13.5913 579.18 0.738037H564.348C564.348 5.41196 563.051 13.0378 565.09 16.9738C568.427 23.3697 577.079 26.8136 580.663 33.2095H582.147C583.939 36.346 587.029 38.8059 589.562 41.3274C590.798 42.5574 596.917 47.1083 596.978 48.7073C597.164 52.2127 584.186 60.5151 582.147 64.205H580.663C577.141 70.4165 569.539 73.7374 565.832 79.7028C563.236 83.8232 564.348 90.0961 564.348 95.2006H579.18C586.287 82.5933 603.096 77.0583 610.327 64.205H613.293C620.215 76.4434 636.097 82.9623 642.957 95.2006H659.272C659.272 90.0961 660.261 83.8847 657.789 79.7028C654.204 73.6759 646.418 70.4165 642.957 64.205H641.474C639.682 61.0686 636.592 58.6086 634.058 56.0872C632.822 54.8572 626.704 50.3063 626.642 48.7073C626.457 45.2018 639.434 36.8995 641.474 33.2095V33.2095Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.27 0.738037V21.4017H699.383V95.2006H718.664V21.4017H754.26V0.738037H665.27Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.488 24.3537V95.2006H558.479V76.0129H490.253V58.3011H537.715V37.6375H490.253V24.3537H558.479V0.738037H469.488V24.3537Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7617 24.3537V95.2006H180.269V76.0129H112.043V58.3011H180.269V37.6375H112.043V24.3537H180.269V0.738037H92.7617V24.3537Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.742188 21.4017H33.4339V95.2006H54.1984V21.4017H88.3116V0.738037H0.742188V21.4017Z",
    stroke: "#FFC925",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_3404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 755,
    height: 96,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexhnxt);
export default __webpack_public_path__ + "static/media/texhnxt.7e7fb3d90e6d6f5152824a5c3001e019.svg";
export { ForwardRef as ReactComponent };